export default __webpack_public_path__ + "static/media/social-google.9887eb8e.svg";